import type { EventRule } from "../lib/project-tracking";

export const META_HQ_ONLY_LABEL = "An Meta nur HQ-Leads als Lead melden";

/**
 * TASK-254 (S15): per-rule option, same meaning as the switch on a data source. Absent = off,
 * so existing rules stay as they are. Offered for Lead and HQLead rules only. On a Lead rule
 * the option means "this Lead never goes to Meta" - so no pixel either: ticking it switches
 * the pixel (and its confirmation) off in the same patch.
 */
export function RuleMetaHqOnly({
  rule,
  onChange,
}: {
  rule: Pick<EventRule, "event_type" | "meta_hq_only">;
  onChange: (patch: Partial<EventRule>) => void;
}) {
  const type = rule.event_type.trim();
  if (type !== "Lead" && type !== "HQLead") return null;
  const on = rule.meta_hq_only === true;
  return (
    <>
      <label className="flex items-center gap-1 text-xs text-text-secondary">
        <input
          type="checkbox"
          checked={on}
          onChange={(e) =>
            onChange(
              e.target.checked
                ? type === "Lead"
                  ? { meta_hq_only: true, browser: false, pixel_confirm: false }
                  : { meta_hq_only: true }
                : { meta_hq_only: false },
            )
          }
        />{" "}
        {META_HQ_ONLY_LABEL}
      </label>
      {on && (
        <span className="w-full text-[10px] text-text-tertiary">
          {type === "Lead"
            ? "Dieser Lead geht nicht an Meta und löst kein Pixel aus. Er bleibt im Tool und geht wie bisher an Google."
            : "Dieser HQ-Lead geht als „Lead“ an Meta, wenn Lead oben in der Tabelle angehakt ist, und feuert den Pixel „Lead“. Ohne dieses Häkchen bleibt es das eigene Ereignis „HQLead“."}
        </span>
      )}
    </>
  );
}
